import { useQuery } from "@apollo/client"
import React, {Fragment} from 'react'
import { getPurchaseOrderById } from "../api"
import Navbar from "../../../components/Navbar"
import { Loader } from "../../../components/Loader"
import { ErrorMessage } from "../../../components/ErrorMessage"
import { EditPurchaseOrderForm } from "./EditPurchaseOrderForm"

export const EditPurchaseOrderPage = (props) => {
  const { loading, error, data } = useQuery(getPurchaseOrderById, {
    variables: {id: parseFloat(props.match.params.poId)}
  })

  if(loading){
    return(
      <Fragment>
        <Navbar/>
        <Loader/>
      </Fragment>
    )
  }

  if(error){
    return (
      <Fragment>
        <Navbar />
        <ErrorMessage title='Whoops! Error at /src/pages/PurchaseOrders/EditPurchaseOrder/index' />
       
      </Fragment>
    );
  }

  if(data){
    return(
      <Fragment>
        <Navbar/>
        <div className="m-2">
          <EditPurchaseOrderForm data={data.getPurchaseOrderById}/>
        </div>
      </Fragment>
    )
  }
}